import { Radio } from "$components/rhf/radio";
import { styled } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { useController } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import {
  type FormValues,
  PrivacyPolicyLink,
  SoftwareTermsOfUseLink,
} from "../common";

const YesRadio = ({ name }) => {
  const { field, fieldState } = useController<FormValues, "privacyPolicy">({
    name,
  });

  return (
    <Radio
      checked={field.value === true}
      onClick={() => field.onChange(true)}
      error={!!fieldState.error}
      data-testid="privacyPolicy.yes"
    >
      <Typography>
        <FormattedMessage
          id="kenyaConsentForm.privacyPolicy.yes"
          defaultMessage={"Yes"}
        />
      </Typography>
    </Radio>
  );
};

const ConsentContainer = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1),
  justifyContent: "flex-start",
  alignItems: "center",
  marginBottom: "1rem",
}));

const PrivacyPolicyConsent = () => (
  <ConsentContainer>
    <Typography variant="body1">
      <FormattedMessage
        id="first-sign-in.kenya.privacyConfirmation"
        defaultMessage="Do you confirm that you are happy for your information to be processed in this way?"
      />
    </Typography>
    <YesRadio name="privacyPolicy" />
  </ConsentContainer>
);

export const KenyaPrivacyPolicy = () => {
  return (
    <div data-testid="privacyPolicy.kenya">
      <Typography variant="body1" paragraph>
        <FormattedMessage
          id="first-sign-in.kenya.privacyTerms"
          defaultMessage="Elephant must process your personal information in order to set up your professional user account. To keep your information safe it will be encrypted and stored on servers in Kenya and/or the European Union and processed in accordance with Elephant’s {PrivacyPolicyLink}. "
          values={{
            PrivacyPolicyLink: <PrivacyPolicyLink />,
          }}
        />
      </Typography>

      <PrivacyPolicyConsent />

      <Typography variant="body1">
        <FormattedMessage
          id="first-sign-in.kenya.softwareTermsOfUse"
          defaultMessage="By using Elephant, you agree to our {SoftwareTermsOfUseLink}."
          values={{
            SoftwareTermsOfUseLink: <SoftwareTermsOfUseLink />,
          }}
        />
      </Typography>
    </div>
  );
};
